import type { SubscriptionV2Template } from "@/pages/subscriptions/services/types";
import type { Platform } from "./templateSelectionConstants";

export const filterTemplatesByPlatform = (
  templates: SubscriptionV2Template[],
  selectedPlatform: Platform
) =>
  templates.filter(template => {
    const platformMatches = template.platform === selectedPlatform || template.platform === "all";
    if (!platformMatches) return false;

    if (selectedPlatform === "databricks") {
      const metricName = template.metric_config?.metric_name ?? "";
      return metricName.startsWith("dbx_");
    }

    return true;
  });

export const getTemplateSources = (templates: SubscriptionV2Template[]) => {
  const seen = new Set<string>();
  const ordered: string[] = [];

  templates.forEach(template => {
    if (template.group?.key && !seen.has(template.group.key)) {
      seen.add(template.group.key);
      ordered.push(template.group.key);
    }
  });

  return ordered;
};

export const getTemplateSourceInfoMap = (templates: SubscriptionV2Template[]) =>
  templates.reduce<Record<string, { label: string; icon: string }>>((acc, template) => {
    if (template.group?.key && !acc[template.group.key]) {
      acc[template.group.key] = {
        label: template.group.label,
        icon: template.group.icon ?? "",
      };
    }

    return acc;
  }, {});
